export default class EventEmitter {
	events: { [key: string]: Array<Function> };
	rejectSubscribeList: Array<RegExp> = [];

	constructor() {
		this.events = {};
		if ((window as any).isMobile) {
			this.rejectSubscribeList = [/^event:[A-Za-z0-9]+$/, /^trigger:[A-Za-z0-9]+$/];
		}
	}

	emit(eventName: string, data: any) {
		const promises: Array<Promise<any>> = [];
		const event = this.events[eventName] ? [...this.events[eventName]] : [];

		if (event) {
			event.forEach(fn => {
				const result = fn.call(null, data);
				if (result === false) {
					promises.push(Promise.reject(result));
				} else if (result instanceof Promise) {
					promises.push(result);
				} else {
					promises.push(Promise.resolve(result));
				}
			});
		}

		return Promise.all(promises);
	}

	off(eventName?: string, event?: Function) {
		if (eventName) {
			if (event) {
				const fnIndex = this.events[eventName].findIndex(fn => fn === event);
				if (fnIndex > -1) {
					this.events[eventName].splice(fnIndex, 1);
				}
			} else {
				delete this.events[eventName];
			}
		} else {
			this.events = {};
		}
	}

	private allowSubscribe(eventName: string) {
		if (!this.rejectSubscribeList.length) {
			return true;
		}
		return !this.rejectSubscribeList.some(expr => expr.test(eventName));
	}

	subscribe(eventName: string, func: Function) {
		if (this.allowSubscribe(eventName)) {
			if (!this.events[eventName]) {
				this.events[eventName] = new Array();
			}

			this.events[eventName].push(func);
			return () => {
				this.events[eventName] = this.events[eventName].filter(eventFn => func !== eventFn);
			};
		}
	}

	hasSubscriber(eventName: string) {
		return this.events[eventName] ? this.events[eventName].length > 0 : false;
	}
}
